<template>
  <v-autocomplete
    v-model="value.selecionado"
    :item-text="getUnidadeSiglaAndNome"
    :items="unidades"
    :disabled="disabled"
    item-value="id"
    class="mx-2"
    label="Unidade"
    prepend-icon="account_balance"
    placeholder="Digite para pesquisar..."
    return-object
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SelectSimpleUnidade',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        selecionado: null,
      }),
    },
    mapeamentoId: {
      type: Number,
      required: false,
      default: null,
    },
    listaUnidades: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
      mapeamentosComissao: (state) => state.mapeamento.mapeamentosComissao,
    }),
    ...mapGetters({
      getUnidadesByAcesso: 'unidade/getUnidadesByAcesso',
    }),
    unidades() {
      if (!this.mapeamentoId) {
        return this.$store.state.unidade.unidades;
      }
      let unidades;
      if (this.comissao) {
        // necessário informar o mapeamento? será sempre o selecionado, não?
        const mapeamento = this.mapeamentosComissao.find((m) => m.id === this.mapeamentoId);
        unidades = [mapeamento.unidade, ...mapeamento.unidades];
      } else {
        unidades = this.getUnidadesByAcesso('COMUM', this.mapeamentoId);
      }

      return unidades.sort((a, b) => a.nome.localeCompare(b.nome));
    },
  },

  watch: {
    'value.selecionado': function () {
      this.$emit('input');
    },
  },

  methods: {
    getUnidadeSiglaAndNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
  },
};
</script>
